import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import Header from "../component/Header";
import Footer from "../component/Footer";
import ProductCard from "../component/ProductCard";

import $ from "jquery";

import { API_BASE_URL, IMAGE_URL } from "../utils/app_url";
import { useAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";

const SeasonProductList = () => {
    const { storeId, seasonId } = useParams();
    const { user } = useAuth();
    const { selectedLanguage, langJson } = useLanguage();



    const [products, setProducts] = useState([]);
    const [season, setSeason] = useState(null);
    const [wishBtn, setWishBtn] = useState(false);
    const [wishMsg, setWishMsg] = useState(false);
    const [openModal, setOpenModal] = useState();
    const [store, setStore] = useState(null);
    const [loading, setLoading] = useState(false);

    /* ------------------------
       FETCH SEASON PRODUCTS
    ------------------------ */
    const fetchSeasonProducts = async () => {
        setLoading(true);

        try {
            const response = await fetch(`${API_BASE_URL}frontend/store/products`, {
                method: "POST",
                body: JSON.stringify({
                    store_id: storeId,
                    season_id: seasonId,
                    lang: selectedLanguage,
                    user_id: user?.id,
                }),
                headers: {
                    "Content-Type": "application/json",
                },
            });

            const res = await response.json();

            setProducts(res?.data?.products || []);
        } catch (err) {
            console.error("Season product fetch error:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleAddWishlist = async (productId) => {
        if (!user) {
            $(".loginLink").click(() => {
                $(".loginPopup").addClass("active");
            });
            setOpenModal(!openModal);
        } else {
            setWishMsg(null);
            setWishBtn(true);
            try {
                const response = await fetch(`${API_BASE_URL}frontend/wishlists`, {
                    method: "POST",
                    body: JSON.stringify({
                        product_id: productId,
                        lang: selectedLanguage,
                    }),
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${user?.authorisation?.token}`,
                    },
                });
                const responseData = await response.json();
                if (responseData.res === true) {
                    setWishMsg(responseData.msg);
                    setWishBtn(false);
                } else {
                    setWishMsg(responseData.msg);
                    setWishBtn(false);
                }
                setTimeout(() => {
                    setWishMsg(null);
                }, 5000);
            } catch (error) {
                console.error("Error during Sign UP:", error);
                setWishBtn(false);
            }
        }
    };

    useEffect(() => {
        fetchSeasonProducts();
    }, [seasonId, selectedLanguage, user]);

    useEffect(() => {
        if (!storeId) return;

        fetch(`${API_BASE_URL}frontend/store/${storeId}`, {
            headers: {
                Authorization: `Bearer ${user?.authorisation?.token}`,
            },
        })
            .then(res => res.json())
            .then(res => {
                if (res?.res && res?.data?.store) {
                    setStore(res.data.store);
                }
            })
            .catch(err => console.error("Store fetch error:", err));
    }, [storeId, user]);

    return (
        <div>
            <Header />
            <style>{`body { background: #FFF; }`}</style>

            <div className="mainDiv">
                <div className="manPrdtDtls">
                    {store && (
                        <div className="fairTop fairStore">

                            <div className="fairLft singleLogo">
                                <div className="logoLft">
                                    <Link to={`/stores/${store.id}`}>
                                        <img
                                            src={store.logo ? IMAGE_URL + store.logo : ""}
                                            alt={store.name || "Store"}
                                        />
                                    </Link>
                                </div>
                                <div className="logoRgt">
                                    <Link to={`/stores/${store.id}`} className="linkStore">
                                        <h2>{store.name}</h2>
                                    </Link>
                                </div>
                            </div>

                        </div>
                    )}
                    <div className="tradePrdts">
                        <div className="featureDiv collectionPrdtList">
                            <h2 className="storeTabHdn">
                                {season?.name || langJson?.seasonproducts}
                            </h2>

                            {loading && <p>{langJson?.loading}</p>}

                            {!loading && products.length === 0 && (
                                <p>{langJson?.noproductfound}</p>
                            )}

                            <div className="productList">
                                <ul className="products new-products">
                                    {products.map((product) => (
                                        <ProductCard
                                            key={product.id}
                                            product={product}
                                            handleAddWishlist={() => { }}
                                        />
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default SeasonProductList;
